import { useEffect } from 'react'

const useABTasty = () => {
    useEffect(() => {
        function handleConsentChange (consent) {
            if (isABTastyEnabled(consent)) {
                dispatchCustomEvent('abtasty_grantConsent')
            } else {
                dispatchCustomEvent('abtasty_revokeConsent')
            }
        }

        function isABTastyEnabled (consent) {
            return (
                consent.standard[1] &&
                consent.standard[2] &&
                consent.standard[3] &&
                consent.standard[4] &&
                consent.standard[7] &&
                consent.standard[8] &&
                consent.nonTCFVendors[31]
            )
        }

        function dispatchCustomEvent (eventName) {
            // eslint-disable-next-line no-undef
            const event = new CustomEvent(eventName, {})
            console.log('Dispatching custom event:', event)
            window.dispatchEvent(event)
        }

        function consentListener (event) {
            const consentData = event.detail
            if (consentData) {
                handleConsentChange(consentData)
            }
        }

        window.addEventListener('alma_cmp_v2_consent_available', consentListener, false)
        window.addEventListener('alma_cmp_v2_has_optedin', consentListener, false)

        // Cleanup event listeners on component unmount
        return () => {
            window.removeEventListener('alma_cmp_v2_consent_available', consentListener)
            window.removeEventListener('alma_cmp_v2_has_optedin', consentListener)
        }
    }, [])

    return null
}

export default useABTasty
